import {ResolveFn} from '@angular/router';
import {inject} from '@angular/core';
import {DatasetService} from '../api/fit-api/dataset.service';
import {Dataset} from '../api/fit-api/models/datasets/dataset';

export const financialHealthDatasetsResolver: ResolveFn<Array<Dataset>> = () => {
	const datasetService = inject(DatasetService);

	return datasetService.getDefaultFinancialHealthIndicatorDatasets();
};
